import { Container, Grid, Paper } from '@material-ui/core'
import React, { useState } from 'react'
import { components, useTranslation } from 'cng-web-lib'

import PollingViewForm from './PollingViewForm'
import PollingAddForm from './PollingAddForm'
import PollingEditForm from './PollingEditForm'
import PollingSourceCrudTable from './PollingSourceCrudTable'
import Namespace from 'src/constants/locale/Namespace'
import PollingKeys from 'src/constants/locale/key/Polling'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      UiComponentKeys,
    },
  },
} = constants

const { CngTabs } = components

function AddPage({ history, showNotification }) {
  const [lockedOnFirstTab, setLockedOnFirstTab] = useState(true)
  const [pollingId, setPollingId] = useState('')
  const { translate } = useTranslation([
    Namespace.POLLING,
    Namespace.UI_COMPONENT
  ])
  const translatedTextsObject = makeTranslatedTextsObject()

  function makeTranslatedTextsObject() {
    let polling = translate(
      Namespace.POLLING,
      PollingKeys.TITLE
    )
    let pollingSource = translate(
      Namespace.POLLING,
      PollingKeys.PollingSource.TITLE
    )
    let tabLockedMessage = translate(
      Namespace.UI_COMPONENT,
      UiComponentKeys.Tabs.PLEASE_SUBMIT_FIRST,
      {
        title: polling
      }
    )

    return {
      polling,
      pollingSource,
      tabLockedMessage
    }
  }

  function makePollingForm() {
    if (pollingId === '') {
      return (
        <PollingAddForm
          history={history}
          showNotification={showNotification}
          onPostSubmitSuccess={(datum) => {
            setPollingId(datum.id)
            setLockedOnFirstTab(false)
          }}
        />
      )
    } else {
      return (
        <PollingEditForm
          showNotification={showNotification}
          id={pollingId}
        />
      )
    }
  }

  return (
    <Grid container spacing={3}>
      <Grid item xs={12}>
        <Paper>
          <Container maxWidth='xl'>
            <PollingViewForm
              showNotification={showNotification}
              id={pollingId}
            />
          </Container>
        </Paper>
      </Grid>
      <Grid item xs={12}>
        <CngTabs
          headerColor='primary'
          tabs={[
            {
              tabName: translatedTextsObject.polling,
              tabContent: makePollingForm()
            },
            {
              tabName: translatedTextsObject.pollingSource,
              tabContent: (
                <PollingSourceCrudTable
                  showNotification={showNotification}
                  pollingId={pollingId}
                />
              )
            },
          ]}
          lockedOnFirstTab={lockedOnFirstTab}
          tabLockedMessage={translatedTextsObject.tabLockedMessage}
        />
      </Grid>
    </Grid>
  )
}

export default AddPage